import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.GRAPHQL_URL + 'agents/',
  fetchPaginated (options = {}) {
    const { page, search, limit } = {
      ...options
    }
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}?limit=${limit}&page=${page}` + (search ? `&search=${search}` : ''))
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}`, payload)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  update ({ payload }) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}/${payload.id}`, payload)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  }
}
